<template>
    <div class="configurator-steps container-fluid mb-2 px-0">
        <ul class="nav nav-tabs d-flex" :class="{'justify-content-center': product_configurator_id === 3 && editPlanning }" id="myTab" role="tablist">
            <li class="col-auto px-0 text-center text-white step-column nav-item" v-if="product_configurator_id !== 3">
                <a class="nav-link" :class="{ 'disabled': !clickableSteps.includes(1), 'active': current_step === 1 }" @click.prevent="goToStep(1)" id="luminaire-selection-step-tab" data-toggle="tab" role="tab" aria-controls="luminaire-selection-step" :aria-selected="this.current_step === 1 ? 'true' : 'false'">
                    <div class="step-number mx-auto mb-2">1</div>
                    <p class="step-title mb-0"><small>{{ $t('Configure luminaire') }}</small></p>
                </a>
            </li>
            <li v-if="!editPlanning && product_configurator_id !== 3" class="flex-grow-1 px-0 text-center text-white step-column nav-item">
                <div class="step-divider"></div>
            </li>
            <li v-if="!editPlanning" class="col-auto px-0 text-center text-white step-column nav-item">
                <a class="nav-link" :class="{ 'disabled': !clickableSteps.includes(2), 'active': current_step === 2 }" @click.prevent="goToStep(2)" id="create-project-step-tab" data-toggle="tab" role="tab" aria-controls="create-project-step" :aria-selected="this.current_step === 2 ? 'true' : 'false'">
                    <div class="step-number mx-auto mb-2">{{ product_configurator_id !== 3 ? '2' : '1' }}</div>
                    <p class="step-title mb-0"><small>{{ $t('Create project') }}</small></p>
                </a>
            </li>
            <li v-if="( product_configurator_id === 3 && !editPlanning ) || product_configurator_id !== 3" class="flex-grow-1 px-0 text-center text-white step-column nav-item">
                <div class="step-divider"></div>
            </li>
            <li class="col-auto px-0 text-center text-white step-column nav-item">
                <a class="nav-link" :class="{ 'disabled': !clickableSteps.includes(3), 'active': current_step === 3 }" @click.prevent="goToStep(3)" id="luminaire-line-configurator-step-tab" data-toggle="tab" role="tab" aria-controls="luminaire-line-configurator-step" :aria-selected="this.current_step === 3 ? 'true' : 'false'">
                    <div class="step-number mx-auto mb-2" v-if="product_configurator_id === 1">{{ !editPlanning ? '3' : '2' }}</div>
                    <div class="step-number mx-auto mb-2" v-else-if="product_configurator_id === 3">{{ !editPlanning ? '2' : '1' }}</div>
                    <p class="step-title mb-0"><small>{{ product_configurator_id !== 3 ? $t('Configure lighting line') : $t('Configure track system') }}</small></p>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: [
            'product_configurator_id',
            'clickableSteps',
            'current_step',
            'editPlanning'
        ],
        data() {
            return {

            }
        },

        methods: {
            goToStep(stepToGo) {
                let stepToGoToIsValidated = this.clickableSteps.includes(stepToGo);

                if ( stepToGoToIsValidated ) {
                    this.$emit('update:current_step', stepToGo);
                } else if ( stepToGo <= this.max_step ) {
                    this.$emit('update:current_step', stepToGo);
                }
            },
        },

    }
</script>
